import { useTranslation } from 'react-i18next';
import { ExperienceStatus } from '@utriper/core';
import { Chip } from '@utriper/core-ui';
import { alpha } from '@mui/material';

export const getStatusColor = (status) => {
    switch (status) {
        case ExperienceStatus.IDS.draft:
            return '#9EC4D6';
        case ExperienceStatus.IDS.live:
            return '#50C878';
        case ExperienceStatus.IDS.archived:
            return '#131313';
        default:
            return '#131313';
    }
};

const ExperienceStatusChip = ({ status, ...props }) => {
    const { i18n } = useTranslation();

    const statusColor = getStatusColor(status);
    const statusLabel = ExperienceStatus.getTranslatedName(ExperienceStatus.status, status ?? 0, i18n.language);

    return <Chip label={statusLabel} sx={{ background: alpha(statusColor, 0.25), color: `${statusColor}`, padding: '8px 4px', borderRadius: '4px' }} {...props} />;
};

export default ExperienceStatusChip;
